import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { LoaderState } from "../Models/interfaces/LoaderState";

@Injectable({
  providedIn: "root",
})
export class LoaderService {
  private loaderSubject = new Subject<LoaderState>();
  loaderState = this.loaderSubject.asObservable();
  tag?: string;

  constructor() {}

  show(tag?: string) {
    if (!this.tag || tag === this.tag) this.loaderSubject.next({ show: true });
  }

  hide(tag?: string) {
    if (!this.tag || tag === this.tag) this.loaderSubject.next({ show: false });
  }
}
